import {
  DEFAULT_FONT_SIZE,
  DEFAULT_TYPE_FONT_SIZE,
  fontSizes,
} from '../../configs/fontSize'

export const getFontSize = (
  fontSize = DEFAULT_FONT_SIZE,
  typeFontSize = DEFAULT_TYPE_FONT_SIZE,
) => {
  return typeof fontSize === 'number'
    ? getSize(fontSize, typeFontSize)
    : fontSize
}

const getSize = (fontSize, typeFontSize = DEFAULT_TYPE_FONT_SIZE) => {
  return fontSize * fontSizes[typeFontSize].ratio
}
